import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import { Stack, styled, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  getCandidateDownloadTemplates,
  getJobsDownloadTemplates,
  IJobsDownloadTemplate,
} from 'wisestep-api';
import { Spinner, CardVariant, WsCard, IUserDTO } from 'wisestep-base';

import { useUserContext } from '../../../context';
import CreateCRMDownloadSettingsTemplate from '../../emailSettings/components/templates/CreateCRMDownloadSettingsTemplate';
import { CreateExcelTemplateProps } from '../../emailSettings/components/templates/CreateExcelTemplate';
import CreateJobsDownloadSettingsTemplate from '../../emailSettings/components/templates/CreateJobsDownloadSettingsTemplate';
import { getFavouredDownloadSettingsTemplatesFirst } from '../helper/TemplateSettingsHelper';

import JobsTemplateListingTable from './JobsTemplateListingTable';

const Styles = styled(Stack)({ padding: '0', gap: 0.5 });
const JobsTemplateSettings = () => {
  const [loadPage, setLoadPage] = useState<boolean>(false);
  const [showCreateTemplate, setShowCreateTemplate] = useState(false);
  const closeDialog = () => setShowCreateTemplate(false);
  const [hasData, setHasData] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [flagType, setFlagType] = useState<CreateExcelTemplateProps['variant']>('new');
  const [templates, setTemplates] = useState<IJobsDownloadTemplate[]>([]);
  const [dataType, setDataType] = useState<string>('jobs');
  const [editOrCloneId, setEditOrCloneId] = useState<string>();
  const loggedInUser = useUserContext().userDTO as IUserDTO;

  useEffect(() => {
    (async function () {
      const getUserDefinedTemplatesReq = await getJobsDownloadTemplates();
      const getUserDefinedCandidateTemplatesReq = await getCandidateDownloadTemplates();
      const allTemplate = [
        ...getUserDefinedCandidateTemplatesReq.data,
        ...getUserDefinedTemplatesReq.data,
      ];
      if (getUserDefinedTemplatesReq.data) {
        setHasData(true);
        setTemplates(getFavouredDownloadSettingsTemplatesFirst(allTemplate, loggedInUser));
        setLoadPage(true);
      }
    })();
  }, [loggedInUser, refresh]);

  const handleDrawer = (type: string) => {
    setDataType(type);
    setShowCreateTemplate(true);
  };

  const getLatestData = () => {
    setRefresh(!refresh);
  };

  return (
    <>
      <Styles>
        <Grid direction="column">
          <Grid>
            {!loadPage ? (
              <Spinner />
            ) : !hasData ? (
              <WsCard
                cardType={CardVariant.WITH_OUT_BG}
                title="No Templates Found"
                description=""
                middleComponent={<FilePresentOutlinedIcon />}
                isButton={true}
                onClick={() => {
                  setFlagType('new');
                  handleDrawer('jobs');
                }}
                buttonText="Create New Template"
              />
            ) : (
              <JobsTemplateListingTable
                templates={templates}
                getLatestData={getLatestData}
                handleDrawer={handleDrawer}
                getFlagType={(flag) => setFlagType(flag)}
                getEditorCloneId={(id) => setEditOrCloneId(id)}
              />
            )}
          </Grid>
        </Grid>
      </Styles>
      {showCreateTemplate &&
        (dataType === 'jobs' ? (
          <CreateJobsDownloadSettingsTemplate
            openDialog={showCreateTemplate}
            closeDialog={closeDialog}
            variant={flagType}
            getLatestData={getLatestData}
            editOrCloneId={editOrCloneId ?? ''}
          />
        ) : (
          <CreateCRMDownloadSettingsTemplate
            openDialog={showCreateTemplate}
            closeDialog={closeDialog}
            variant={flagType}
            getLatestData={getLatestData}
            editOrCloneId={editOrCloneId ?? ''}
          />
        ))}
    </>
  );
};
export default JobsTemplateSettings;
